module.exports = __webpack_public_path__ + "img/8an-fox.ea135704.jpg";